import React from 'react';
import { VyTable } from '../../../../../../components/new-design/table/vy-table/VyTable';
import { useAllCustomers } from '../../../../../../hooks/requests/use-customers';
import { buildMatchedCustomersTableColumns } from './matched-customer-table-consts';

type MatchedCustomerProps = {
  customerAlias: string;
  customerName?: string;
  customerMatchedAt?: Date;
};

export const MatchedCustomers: React.FC<MatchedCustomerProps> = ({
  customerAlias,
  customerName,
  customerMatchedAt,
}) => {
  const { data: customersResponse } = useAllCustomers({
    refetchOnWindowFocus: false,
  });
  const customers = customersResponse?.customers ?? [];
  const tableData = [{ alias: customerAlias, name: customerName, matchedAt: customerMatchedAt }];
  const columns = buildMatchedCustomersTableColumns(customers);

  return (
    <>
      <VyTable
        tableName="matched-customer"
        itemsCount={1}
        items={tableData}
        columns={columns}
        loading={false}
        getRowId={(row) => row.alias}
        showPagination={false}
        sx={{
          '& .MuiDataGrid-row:last-child .MuiDataGrid-cell ': {
            borderBottom: 'none',
          },
        }}
      />
    </>
  );
};
